import React from "react";
import styles from "./TermPopUp.module.css";

interface PolicyProps {
    policy: string;
    onClose: () => void;
}

//개인정보 처리 규정 팝업
const PolicyPopUp: React.FC<PolicyProps> = ({policy, onClose}) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.popup} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        Privacy Policy
                    </div>
                    <button onClick={onClose} className={styles.closeButton}>
                        ×
                    </button>
                </div>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{__html: policy}}
                />
            </div>
        </div>
    )
}

export default PolicyPopUp;